import React from "react";
import { TextArea } from "@blueprintjs/core";

const CategoryRemarkInput = ({
  question,
  value,
  onChange,
  placeholder = "",
  readOnly = false,
  multiline = false,
  width = "60%"
}) => {
  return (
    <div style={{ marginTop: 4, marginBottom: 16 }}>
      {/* Question */}
      <div
        style={{
          fontWeight: "500",
          marginBottom: "10px",
          fontSize: "16px"
        }}
      >
        {question}
      </div>

      {/* ✅ READ ONLY MODE */}
      {readOnly ? (
        <div
          className="read-only-answer-box"
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            width
          }}
        >
          {value || "-"}
        </div>
      ) : (
        <>
          {/* ✏️ EDIT MODE (existing behavior preserved) */}
          {multiline ? (
            <TextArea
              style={{ width }}
              rows={4}
              value={value}
              onChange={e => onChange(e.target.value)}
              placeholder={placeholder}
            />
          ) : (
            <input
              style={{ width }}
              autoComplete="off"
              className="bp3-input question-input-box"
              type="text"
              value={value}
              onChange={e => onChange(e.target.value)}
              placeholder={placeholder}
            />
          )}
        </>
      )}
    </div>
  );
};

export default CategoryRemarkInput;